import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './auth/config.service';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BylawsService {
  societyDetails: BehaviorSubject<any> = new BehaviorSubject({})
  societyRegistration: BehaviorSubject<any | null> = new BehaviorSubject('')
  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }


  // Method for get All GetDisclaimer data
  getDisclaimer() {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetDisclaimer`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
  // Method for get All GetDisclaimer data
  applyAmendsments(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AddNewByLaws`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  applyAmendsments2006(data: any) {
    debugger;
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AddNewByLaws2006`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }

    Amendsmenttypes() {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AmmendmentType`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  // Method for get All GetDisclaimer data
  getAmmendmentList(data: any,date:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AmmendmentDetailCount?iSocietyDetailsId=${data?.iSocietyDetailsId}&filterDate=${date}`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
    getAmmendmentList2006(data: any,date:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AmmendmentDetailCount2006?iSocietyDetailsId=${data?.iSocietyDetailsId}&filterDate=${date}`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  // Method for get All Amendments list data
  getApplicationDeatails(data: any) {
    debugger;
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AmmendmentDetails`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
    getApplicationDetails2006(data: any) {
      debugger;
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/AmmendmentDetails2006`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
    getByLaws2006(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetByLaws2006?bylawsId=${data}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
    getByLaws(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetByLaws?bylawsId=${data}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
  getDropDownData() {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetDropDownData`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  getDropDownData1() {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetDropDownData`;

    return this.http.get<any>(apiUrl).pipe(
      catchError(err => {
        console.error("Error fetching data:", err);
        return throwError(() => new Error('Failed to retrieve data.'));
      })
    );
  }
  getBindRoles(action:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/BindRoles?action=${action}`;

    return this.http.post<any>(apiUrl, {}).pipe(
      catchError(err => {
        console.error("Error fetching data:", err);
        return throwError(() => new Error('Failed to retrieve data.'));
      })
    );
  }
  upateRemark(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/UpdateStatusAndRemark`;

    return this.http.post<any>(apiUrl, data).pipe(
      catchError(err => {
        console.error("Error fetching data:", err);
        return throwError(() => new Error('Failed to retrieve data.'));
      })
    );
  }
  getRemarks(data: any,action:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/BindRemark?iByLawsId=${data}&action=${action}`;

    return this.http.post<any>(apiUrl, {}).pipe(
      catchError(err => {
        console.error("Error fetching data:", err);
        return throwError(() => new Error('Failed to retrieve data.'));
      })
    );
  }
  byLawsVerificationProcess(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/ByLawsVerificationProcess`;

    return this.http.post<any>(apiUrl, data).pipe(
      catchError(err => {
        console.error("Error fetching data:", err);
        return throwError(() => new Error('Failed to retrieve data.'));
      })
    );
  }
  getSocietyList(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetSocietyDetails`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  getBindByLawsOrderDetail(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/BindByLawsOrderDetail?iSocietyDetailsId=${data?.iSocietyDetailsId}&iByLawsId=${data?.iByLawsId}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
  getByLawsProgressDetail(data: any,action:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/ByLawsProgress?iSocietyDetailsId=${data?.iSocietyDetailsId}&iByLawsId=${data?.iByLawsId}&action=${action}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
  getByLawsOrderCertificate(iSocietyDetailsId: any,iByLawsId:any,action:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/ByLawsOrderCertificate?iSocietyDetailsId=${iSocietyDetailsId}&iByLawsId=${iByLawsId}&action=${action}`;
    return this.http.post<any>(apiUrl, {}).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );

  }
  


  downloadPath(path:any){
  return   `${this.configService.getApiUrl()}/ByLaws/DownloadImage?url=${this.configService.getFileUrl()}/ByLaws/${path}`
  }


   VerifyFee() {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/PaymentVerify`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
   GetPaymentVerifyDetails(payload: any, action: string) {

  const apiUrl = `${this.configService.getApiUrl()}/ByLaws/GetPaymentVerifyDetails?action=${action}`;

  return this.http.post<any>(apiUrl, payload).pipe(
    map(response => response),
    catchError(err => {
      return throwError(() => new Error('Retrieved Data failed.'));
    })
  );
}
  VerifyPayment(payload:any,action: string) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/VerifyPayment?action=${action}`;
    return this.http.post<any>(apiUrl,payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }

   uploadBylawsCertificate(payload:any) {
    const apiUrl = `${this.configService.getApiUrl()}/ByLaws/UploadCertificate`;
    return this.http.post<any>(apiUrl,payload).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Retrieved Data failed.'));
      })
    );
  }
  
}
